/** @generated */
// cspell:disable

/** @typedef {import('axios').AxiosInstance} AxiosInstance */

import { SweetPath } from 'sweet-path';

/**
 * @typedef {import('./time-log-get-internal-costs-summary-action-body').TimeLogGetInternalCostsSummaryActionBody} TimeLogGetInternalCostsSummaryActionBody
 */

/**
 * @typedef {import('./time-log-get-internal-costs-summary-action-response').TimeLogGetInternalCostsSummaryActionResponse} TimeLogGetInternalCostsSummaryActionResponse
 */

/**
 * The path of the TimeLogGetInternalCostsSummaryAction action.
 */
export const timeLogGetInternalCostsSummaryActionPath = new SweetPath('/api/time_log/time_log/internal_costs_summary', {
  path: '{param}',
});

/**
 * Creates a contextualized TimeLogGetInternalCostsSummaryAction action.
 *
 * @param {AxiosInstance} axios
 */
export default function createTimeLogGetInternalCostsSummaryAction(axios) {
  /**
   * The timeLogGetInternalCostsSummaryAction action.
   *
   * @param { { headers: Object<string,string>,parameters: Object<string,string|number|boolean>,query: {limit?: number; offset?: number; filter?: Object<string,string|number|boolean>;, sort?: {by: string; order: string;}} } }
   *
   * @returns {Promise<TimeLogGetInternalCostsSummaryActionResponse>}
   */
  function timeLogGetInternalCostsSummaryAction({ headers = {}, parameters = {}, query = {} } = {}) {
    const path = timeLogGetInternalCostsSummaryActionPath.insert(parameters);

    return axios.get(path, { params: query, headers });
  }

  return timeLogGetInternalCostsSummaryAction;
}
